// Sources are fixed read APIs, never server-supplied URLs or control operations.
const readers = Object.freeze({
  action_scenes(client, source) {
    const { sessionId, turnId, actionId } = source
    return client.post('action/scenes', { sessionId, turnId, actionId })
  },
  action_devices(client, source) {
    const { sessionId, turnId, actionId } = source
    return client.post('action/devices', { sessionId, turnId, actionId })
  }
})
export function readDetail(client, source) {
  if (!Object.prototype.hasOwnProperty.call(readers, source.kind)) throw new Error('INVALID_DETAIL_SOURCE')
  return readers[source.kind](client, source)
}
